import {
  FileCode,
  FileIcon,
  FileImage,
  FileSpreadsheet,
  FileText,
  Presentation,
} from "lucide-react";
import type { ReactElement } from "react";

import type { IGeneratedFile } from "@/api/generated-files";

export const getFileIcon = (file: IGeneratedFile): ReactElement => {
  if (file.isImage) {
    return <FileImage className="size-4 text-primary" />;
  }
  if (file.type.includes("presentation")) {
    return <Presentation className="size-4 text-primary" />;
  }
  // NOTE: `text/csv` carries neither "spreadsheet" nor "excel", so a generated
  // .csv fell through to the generic file icon while the .xlsx beside it showed a
  // sheet — even though getPreviewSource treats both as spreadsheets and renders
  // them in the same grid viewer. Matched explicitly rather than reusing
  // SPREADSHEET_PREVIEW_MIME_TYPES: that set excludes legacy .xls on purpose,
  // which the "excel" check here still icons correctly.
  if (
    file.type.includes("spreadsheet") ||
    file.type.includes("excel") ||
    file.type === "text/csv"
  ) {
    return <FileSpreadsheet className="size-4 text-primary" />;
  }
  // NOTE: NSAI-6327 — a generated HTML page, the same glyph chat file cards
  // and mobile's list give it.
  if (file.type === "text/html") {
    return <FileCode className="size-4 text-primary" />;
  }
  if (file.type.includes("pdf") || file.type.includes("word")) {
    return <FileText className="size-4 text-primary" />;
  }
  return <FileIcon className="size-4 text-primary" />;
};
